/* MOTUS: własny JS do motywu Concept 6.0.3 (sklep MOTUS). Ładowany w layout/theme.liquid po theme.js (defer).
   Rejestr zmian: CUSTOMIZATIONS.md */
(() => {
  /* 1. Mega menu z zakładkami (snippets/header-nav-mega.liquid): zakładka przełącza się po najechaniu myszą
        z opóźnieniem 150 ms, jak na heybike. Kliknięcie i klawiatura (strzałki, Home, End) działają jak w Concept
        (TabsElement w theme.js). Delegacja na document, bo treść mega menu doładowuje się przez Section Rendering API. */
  const HOVER_DELAY = 150;
  const TAB_SELECTOR = '.mega-menu__nav--tabs button[role="tab"]';
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let hoverTimer = null;

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !finePointer.matches) return;
    const button = event.target instanceof Element ? event.target.closest(TAB_SELECTOR) : null;
    if (!button || button.getAttribute('aria-selected') === 'true') return;
    const tabs = button.closest('tabs-element');
    if (!tabs || !Array.isArray(tabs.buttons)) return;

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      const index = tabs.buttons.indexOf(button);
      if (index > -1 && button.isConnected) tabs.selectedIndex = index;
    }, HOVER_DELAY);
  });

  document.addEventListener('pointerout', (event) => {
    const button = event.target instanceof Element ? event.target.closest(TAB_SELECTOR) : null;
    if (button && !button.contains(event.relatedTarget)) clearTimeout(hoverTimer);
  });
})();

/* 2. "MOTUS w akcji" - filmy klientów na karcie produktu (snippets/motus-ugc.liquid, CUSTOMIZATIONS.md sekcja 10).
      Miniatury: bez dźwięku, same startują, gdy są widoczne (IntersectionObserver), i stają, gdy znikną z ekranu.
      Bez autoodtwarzania przy prefers-reduced-motion i trybie oszczędzania danych (widać plakat i ikonę odtwarzania).
      Klik: natywny <dialog> z tym samym filmem z dźwiękiem i kontrolkami. Esc, X i klik w tło zamykają,
      showModal() trzyma fokus w oknie, po zamknięciu fokus wraca na kliknięty kafel. Bez zewnętrznych bibliotek. */
(() => {
  const ROOT = '[data-motus-ugc]';
  const THUMB = '.motus-ugc__video';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  let dialog = null;
  let opener = null;
  let observer = null;

  const canAutoplay = () => !reducedMotion.matches && !saveData && !(dialog && dialog.open);

  const play = (video) => {
    video.muted = true;
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  };

  const onIntersect = (entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && canAutoplay()) play(video);
      else if (!video.paused) video.pause();
    });
  };

  const init = () => {
    const videos = document.querySelectorAll(`${ROOT} ${THUMB}:not([data-motus-ugc-ready])`);
    if (!videos.length) return;
    if (!observer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.6 });
    }
    videos.forEach((video) => {
      video.setAttribute('data-motus-ugc-ready', '');
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('autoplay');
      if (observer) observer.observe(video);
    });
  };

  const visibleThumbs = () => Array.from(document.querySelectorAll(`${ROOT} ${THUMB}`)).filter((video) => {
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  });

  const closeDialog = () => {
    if (dialog && dialog.open) dialog.close();
  };

  const onDialogClose = () => {
    const video = dialog.querySelector('video');
    video.pause();
    video.removeAttribute('poster');
    video.replaceChildren();
    video.removeAttribute('src');
    video.load();
    document.documentElement.classList.remove('motus-ugc-dialog-open');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
    if (canAutoplay()) visibleThumbs().forEach(play);
  };

  const getDialog = (root) => {
    if (dialog && dialog.isConnected) return dialog;
    const template = root.querySelector('template[data-motus-ugc-dialog]');
    if (!template || typeof HTMLDialogElement === 'undefined') return null;
    dialog = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(dialog);
    dialog.addEventListener('close', onDialogClose);
    dialog.addEventListener('click', (event) => {
      /* klik w tło: cel to sam <dialog> (jego wnętrze ma własne elementy), albo przycisk X */
      if (event.target === dialog || event.target.closest('[data-motus-ugc-close]')) closeDialog();
    });
    return dialog;
  };

  const openDialog = (button) => {
    const root = button.closest(ROOT);
    const thumb = button.querySelector('video');
    const modal = root && thumb ? getDialog(root) : null;
    if (!modal) return;

    const video = modal.querySelector('video');
    const caption = modal.querySelector('[data-motus-ugc-caption]');
    const author = button.getAttribute('data-author') || '';
    const text = button.getAttribute('data-caption') || '';

    document.querySelectorAll(`${ROOT} ${THUMB}`).forEach((item) => item.pause());

    video.replaceChildren(...Array.from(thumb.querySelectorAll('source')).map((source) => source.cloneNode(true)));
    if (!video.children.length && thumb.currentSrc) video.src = thumb.currentSrc;
    if (thumb.poster) video.poster = thumb.poster;
    video.muted = false;
    video.load();

    caption.replaceChildren();
    if (author) {
      const strong = document.createElement('strong');
      strong.textContent = author;
      caption.append(strong);
    }
    if (text) caption.append(document.createTextNode(author ? ` ${text}` : text));
    caption.hidden = !author && !text;
    const motusT = window.motusTeksty || {};
    modal.setAttribute('aria-label', author ? (motusT.filmKlientaAutor || 'Film klienta {autor}').replace('{autor}', () => author) : (motusT.filmKlienta || 'Film klienta'));

    opener = button;
    document.documentElement.classList.add('motus-ugc-dialog-open');
    modal.showModal();
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(`${ROOT} [data-motus-ugc-open]`) : null;
    if (!button) return;
    event.preventDefault();
    openDialog(button);
  });

  /* Treść karty produktu może się podmienić (zmiana wariantu, edytor motywu), więc nowe filmy dopinamy po zmianach DOM. */
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(() => {
      pending = false;
      init();
    });
  };

  let watching = false;
  const watch = () => {
    init();
    /* obserwator DOM tylko na stronach, na których pas jest (karta produktu), żeby nie obciążać reszty sklepu */
    if (watching || !document.querySelector(ROOT)) return;
    watching = true;
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) document.querySelectorAll(`${ROOT} ${THUMB}`).forEach((video) => video.pause());
    else visibleThumbs().forEach(play);
  });
})();

/* 3. Tooltip "?" przy usługach w bloku product_bundle na PDP (sections/main-product.liquid, CRO 09 rozdz. 6,
      CUSTOMIZATIONS.md sekcja 11). Przycisk [data-motus-tip] stoi poza <label>, więc klik nie zaznacza usługi.
      Klik, dotyk, Enter i Spacja przełączają dymek (aria-expanded + hidden), otwarty jest najwyżej jeden.
      Esc zamyka i oddaje fokus na "?", klik poza dymkiem i wyjście fokusem poza wiersz też zamykają.
      Delegacja na document, bo treść karty produktu podmienia się przy zmianie wariantu. Bez zewnętrznych bibliotek. */
(() => {
  const BUTTON = '[data-motus-tip]';
  let current = null;

  const bubbleOf = (button) => document.getElementById(button.getAttribute('aria-controls') || '');

  const close = (returnFocus = false) => {
    if (!current) return;
    const button = current;
    current = null;
    button.setAttribute('aria-expanded', 'false');
    const bubble = bubbleOf(button);
    if (bubble) bubble.hidden = true;
    if (returnFocus && button.isConnected) button.focus();
  };

  const open = (button) => {
    const bubble = bubbleOf(button);
    if (!bubble) return;
    close();
    button.setAttribute('aria-expanded', 'true');
    bubble.hidden = false;
    current = button;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target ? target.closest(BUTTON) : null;
    if (button) {
      event.preventDefault();
      if (button === current) close();
      else open(button);
      return;
    }
    if (!current) return;
    const bubble = bubbleOf(current);
    if (!(bubble && target && bubble.contains(target))) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !current) return;
    const row = current.parentElement;
    const active = document.activeElement;
    close(!active || active === document.body || Boolean(row && row.contains(active)));
  });

  document.addEventListener('focusout', (event) => {
    if (!current) return;
    const row = current.parentElement;
    const next = event.relatedTarget;
    if (next instanceof Node && row && !row.contains(next)) close();
  });
})();

/* 4. Dwa bloki product_bundle na PDP pojazdu: usługi i "Dobierz do zestawu" (akcesoria z custom.akcesoria), oba natywne
      Concepta (sections/main-product.liquid, CUSTOMIZATIONS.md sekcje 14 i 17 "Poprawki PDP ze zrzutów Mateusza"). Zaznaczanie, wybór wariantu akcesorium
      (podmiana id, ceny i zdjęcia), dodanie do koszyka razem z pojazdem i odznaczenie po dodaniu robi sam Concept
      (theme.js: ProductBundleDetails, ProductBundlePicker, ProductForm). Tu tylko to, czego Concept nie przewiduje przy
      dwóch blokach:
      a) Suma na przycisku z OBU bloków: ProductBundleDetails wysyła bundle:change tylko z zaznaczeniami swojego bloku,
         a product-buy-price (przycisk główny i przyklejony pasek) liczy cenę bazową + detail.items. Nasłuch w fazie
         capture na document działa przed product-buy-price (słucha na formularzu) i podmienia detail.items na wszystkie
         zaznaczone checkboxy tego formularza, tak jak ProductForm buduje żądanie /cart/add.
      b) Po zmianie wariantu pojazdu Concept podmienia cenę na przycisku (bez dodatków) i treść pierwszego bloku (usługi),
         a drugi blok (własne id) zostaje z zaznaczeniami, więc suma jest liczona od nowa. */
(() => {
  const checkedFor = (formId) =>
    Array.from(document.querySelectorAll(`[form="${CSS.escape(formId)}"] input[name="bundles"]:checked`));

  const toItem = (input) => ({
    id: input.value,
    quantity: input.getAttribute('data-min'),
    price: input.getAttribute('data-price')
  });

  /* a) id formularza zawsze przez getAttribute: formularz produktu ma pole name="id" (wariant), więc form.id to <input>. */
  document.addEventListener('bundle:change', (event) => {
    const form = event.target;
    const formId = form instanceof HTMLFormElement ? form.getAttribute('id') : null;
    if (!formId || !event.detail) return;
    event.detail.items = checkedFor(formId).map(toItem);
  }, true);

  /* b) */
  document.addEventListener('variant:change', (event) => {
    const form = event.target;
    const formId = form instanceof HTMLFormElement ? form.getAttribute('id') : null;
    if (!formId || checkedFor(formId).length === 0) return;
    setTimeout(() => form.dispatchEvent(new CustomEvent('bundle:change', { detail: { items: [] } })), 0);
  }, true);
})();

/* 5. Pasek kotwic na PDP (natywna sekcja Concepta scroll-spy, templates/product.hulajnoga.json, CUSTOMIZATIONS.md sekcja 19).
      Concept szuka celu linku tylko po id (document.getElementById), a sekcje karty produktu mają id zależne od szablonu
      (shopify-section-template--<liczba>__klucz) albo od wpisu metaobiektu (motus-sm-pro-10-gt-16-faq). Dlatego w polu
      "ID sekcji docelowej" linku można podać, po przecinku, kandydatów w tych postaciach (każdy liczy się, gdy cel coś rysuje, g):
        __klucz   sekcja szablonu o tym kluczu (np. __product-details, __sekcje-modelu-gora),
        .klasa    pierwszy element z tą klasą, który coś rysuje (np. .motus-sm--faq = sekcja modelu typu FAQ),
        [atrybut] pierwszy element pasujący do selektora, który coś rysuje,
        #id, id   zwykłe id elementu, jak w Concepcie.
      a) Skrypt zamienia kandydatów na id elementów, które na tej karcie istnieją i coś rysują (g),
         i wpisuje je do data-target, więc kliknięcie i przewinięcie robi dalej Concept (ScrollSpy w theme.js). Link bez celu
         dostaje hidden (np. Scooty 10 Elite nie ma sekcji modelu), a gdy zostanie mniej niż 2 linki, znika cała sekcja
         (sam "do góry" + jeden link to nie nawigacja; Elite ma dziś tylko Parametry).
         Oryginalna wartość pola zostaje w data-motus-target (ponowne przeliczenie po przeładowaniu sekcji w edytorze).
         data-gap (odstęp Concepta pod nagłówkiem przy przewijaniu, domyślnie 20 px) = wysokość paska + 24 px, żeby
         przyklejony pasek nie zasłaniał początku sekcji po kliknięciu.
      b) Concept (ustawienie "Wyróżnienie bieżącej sekcji") liczy aktywny link z offsetTop, czyli względem najbliższego
         przodka z position, a sekcje modelu siedzą w sekcji z position: relative, więc dla nich wynik jest zły.
         Tu aktywny link liczymy z getBoundingClientRect (cel, który przecina linię na 30% wysokości okna, nie wyżej niż
         24 px pod paskiem), w tej samej klatce
         po Concepcie (oba przez requestAnimationFrame), z tymi samymi klasami (active + aria-current), więc wygląd natywny.
      c) Motyw ma "renderowanie strony" (content-visibility: auto od 3. sekcji): sekcje poza ekranem mają wysokość 0, więc
         przewinięcie do dalszej kotwicy lądowało za wysoko. Przy pierwszym kliknięciu linku paska wyłączamy to na tej stronie
         (klasa motus-cv-off na <html>, motus-custom.css sekcja 43), zanim Concept policzy pozycję celu.
      d) Przyklejony pasek zakupu Concepta (product-sticky-form, przy dolnej krawędzi okna, z-index 20) przykrywał pasek kotwic,
         dopóki ten stał jeszcze w swoim miejscu pod kartą produktu (kontrola 27.09: link FAQ nie do kliknięcia na desktopie).
         Przy każdym przewinięciu sprawdzamy, czy prostokąty paska kotwic i karty paska zakupu się przecinają; jeśli tak,
         pasek zakupu dostaje klasę motus-sticky-pod-kotwicami i znika (motus-custom.css sekcja 43). Kiedy pasek kotwic
         przyklei się u góry albo zjedzie niżej, klasa znika, a o widoczności paska zakupu znowu decyduje Concept.
      e) Linki stoją w kolejności swoich celów na stronie (compareDocumentPosition), bo link z kilkoma kandydatami może trafić
         w cel w innym miejscu strony (Opinie: .motus-sm--opinia w sekcjach modelu albo zapasowo __apps-opinie na końcu;
         CUSTOMIZATIONS.md sekcja 24). Aktywny link ma kolor przycisku motywu (motus-custom.css sekcja 43).
      g) Zasada ogólna (28.09.2026, CUSTOMIZATIONS.md wpis "Pasek kotwic: link bez sekcji docelowej znika"): link znika, gdy
         jego cel się nie rysuje. Pewne przypadki odrzuca już Liquid (sections/scroll-spy.liquid: .motus-sm--<typ> bez aktywnego
         wpisu, np. opinia w DRAFT, sekcje modelu bez wpisów; mniej niż 2 linki = paska nie ma w HTML). Tu zabezpieczenie dla
         reszty (sekcja wyłączona w edytorze, element spoza metapól, cel pusty): kandydat liczy się tylko wtedy, gdy element
         jest w DOM, jest widoczny i ma treść (tekst poza <style>/<script>, obraz, film, ramkę, pole formularza albo element
         z shadow DOM, np. widżet aplikacji). Kandydat może być też dowolnym selektorem CSS (#id, [atrybut]). */
(() => {
  let counter = 0;
  const NO_TEXT = 'style, script, template, noscript';
  const MEDIA = 'img, picture, video, iframe, canvas, svg, input, select, textarea';
  const isShown = (el) => !!el && (typeof el.checkVisibility === 'function' ? el.checkVisibility() : el.getClientRects().length > 0);
  /* g) cel "coś rysuje": widoczny i z treścią. Bez pomiaru wysokości: przy content-visibility: auto sekcje poza ekranem
     mają 0 px (patrz c), a mimo to są pełnym celem. */
  const hasContent = (el) => {
    if (!isShown(el)) return false;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      if (node.nodeValue.trim() && !(node.parentElement && node.parentElement.closest(NO_TEXT))) return true;
    }
    if (el.querySelector(MEDIA)) return true;
    return Array.from(el.querySelectorAll('*')).some((c) => !!c.shadowRoot);
  };

  const resolve = (raw) => {
    const token = raw.trim();
    if (!token) return null;
    let el = null;
    if (token.startsWith('__')) {
      el = Array.from(document.querySelectorAll('.shopify-section[id]')).find((s) => s.id.endsWith(token)) || null;
    } else if (token.startsWith('#')) {
      el = document.getElementById(token.slice(1));
    } else if (token.startsWith('.') || token.startsWith('[')) {
      try {
        el = Array.from(document.querySelectorAll(token)).find(hasContent) || null;
      } catch (e) {
        el = null;
      }
    } else {
      el = document.getElementById(token);
    }
    if (!hasContent(el)) return null;
    if (!el.id) {
      counter += 1;
      el.id = `motus-kotwica-${counter}`;
    }
    return el.id;
  };

  const init = (nav) => {
    let shown = 0;
    nav.querySelectorAll('.scrollspy-link').forEach((link) => {
      if (!link.hasAttribute('data-motus-target')) {
        link.setAttribute('data-motus-target', link.getAttribute('data-target') || '');
      }
      const ids = [];
      link.getAttribute('data-motus-target').split(',').forEach((token) => {
        const id = resolve(token);
        if (id && !ids.includes(id)) ids.push(id);
      });
      const item = link.closest('li');
      if (ids.length) {
        link.setAttribute('data-target', ids.join(','));
        link.setAttribute('href', `#${ids[0]}`);
        if (item) item.hidden = false;
        shown += 1;
      } else if (item) {
        item.hidden = true;
      }
    });
    /* e) kolejność linków = kolejność celów na stronie (uwaga Mateusza 27.09: "Opinie" ma stać tam, gdzie sekcja opinii).
       W szablonie linki stoją już w kolejności sekcji, ale link z kilkoma kandydatami może trafić w cel w innym miejscu
       strony (np. Opinie: .motus-sm--opinia w sekcjach modelu albo zapasowo __apps-opinie na końcu). Przestawiamy tylko
       elementy li z widocznymi linkami, między sobą; "do góry" i ukryte zostają na swoich miejscach. */
    const entries = [];
    nav.querySelectorAll('.scrollspy-link').forEach((link) => {
      const item = link.closest('li');
      const target = document.getElementById((link.getAttribute('data-target') || '').split(',')[0]);
      if (item && !item.hidden && target) entries.push({ item, target });
    });
    const sorted = entries.slice().sort((a, b) => {
      if (a.target === b.target) return 0;
      return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    if (sorted.some((entry, i) => entry !== entries[i])) {
      const slots = entries.map(({ item }) => {
        const slot = document.createComment('motus-kotwica');
        item.replaceWith(slot);
        return slot;
      });
      slots.forEach((slot, i) => slot.replaceWith(sorted[i].item));
    }
    const section = nav.closest('.shopify-section');
    if (section) section.hidden = shown < 2;
    /* data-gap = odstęp, który Concept odejmuje od pozycji celu (domyślnie 20 px pod nagłówkiem): tu wysokość paska + 24 px,
       żeby przyklejony pasek nie zasłaniał początku sekcji po kliknięciu */
    if (shown > 0 && nav.offsetHeight > 0) nav.setAttribute('data-gap', String(Math.round(nav.offsetHeight + 24)));
  };

  /* b) */
  const highlight = (nav) => {
    if (!nav.hasAttribute('data-highlight')) return;
    /* linia = 30% wysokości okna, ale nie wyżej niż 24 px pod przyklejonym paskiem (top sekcji z CSS Concepta + wysokość
       paska); nagłówek chowa się przy przewijaniu w dół, więc sama krawędź paska skakałaby o wysokość nagłówka */
    const section = nav.closest('.shopify-section');
    const stickyTop = section ? parseFloat(getComputedStyle(section).top) || 0 : 0;
    const line = Math.max(stickyTop + nav.offsetHeight + 24, window.innerHeight * 0.3);
    let current = null;
    nav.querySelectorAll('.scrollspy-link').forEach((link) => {
      const item = link.closest('li');
      if (item && item.hidden) return;
      (link.getAttribute('data-target') || '').split(',').forEach((id) => {
        const el = id ? document.getElementById(id) : null;
        if (!el) return;
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= line && r.bottom > line) current = link;
      });
    });
    nav.querySelectorAll('.scrollspy-link').forEach((link) => {
      const on = link === current;
      link.classList.toggle('active', on);
      if (on) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };

  /* d) */
  const uncover = () => {
    const forms = document.querySelectorAll('product-sticky-form');
    if (!forms.length) return;
    const navs = Array.from(document.querySelectorAll('nav.scrollspy-nav')).filter((nav) => nav.offsetHeight > 0);
    forms.forEach((form) => {
      const card = form.firstElementChild;
      if (!card) return;
      const c = card.getBoundingClientRect();
      const hit = navs.some((nav) => {
        const r = nav.getBoundingClientRect();
        return r.bottom > c.top && r.top < c.bottom && r.right > c.left && r.left < c.right;
      });
      form.classList.toggle('motus-sticky-pod-kotwicami', hit);
    });
  };

  let frame = null;
  const onScroll = () => {
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      document.querySelectorAll('nav.scrollspy-nav').forEach(highlight);
      uncover();
    });
  };

  const run = () => {
    document.querySelectorAll('nav.scrollspy-nav').forEach(init);
    onScroll();
  };

  /* f) nagłówek, który chowa się przy przewijaniu w dół: telefon z dokiem mobilnym Concepta (mobile-dock.css, do 767 px)
     albo nagłówek "przy przewijaniu w górę". Wtedy pasek kotwic podjeżdża pod górną krawędź okna (8 px), a Concept przy
     kliknięciu odejmuje od celu wysokość nagłówka z tej chwili, więc sekcja lądowała ok. 108 px pod paskiem zamiast 16 px
     (telefon 375, kontrola 27.09, CUSTOMIZATIONS.md sekcja 26). Przy przewijaniu w dół data-gap pomniejszamy o tę wysokość. */
  const headerHides = () => {
    const section = document.querySelector('.header-section.header-sticky');
    if (!section) return false;
    if (section.getAttribute('data-sticky-type') === 'on-scroll-up') return true;
    return window.matchMedia('(max-width: 767px)').matches && !!document.querySelector('.mobile-dock-section');
  };

  /* c) capture: przed obsługą kliknięcia w ScrollSpy (nasłuch na samym linku) */
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('.scrollspy-nav .scrollspy-link') : null;
    if (!link) return;
    document.documentElement.classList.add('motus-cv-off');
    /* f) */
    const nav = link.closest('nav.scrollspy-nav');
    const target = document.getElementById((link.getAttribute('data-target') || '').split(',')[0]);
    if (!nav || !target || nav.offsetHeight === 0) return;
    let gap = nav.offsetHeight + 24;
    const header = document.querySelector('.header-section header[is="sticky-header"]');
    if (header && headerHides() && target.getBoundingClientRect().top > gap + 1) {
      gap -= header.getBoundingClientRect().height;
    }
    nav.setAttribute('data-gap', String(Math.round(gap)));
  }, true);

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', () => setTimeout(run, 0));
})();

/* 6. Koszyk: panel "Dodaj usługę do pojazdu" w szufladzie i na /cart (snippets/motus-koszyk-uslugi.liquid, uwaga Michała,
      CUSTOMIZATIONS.md sekcja 20). Klik "Dodaj":
      a) /cart/add.js z jednym wariantem usługi (ilość 1) i listą sekcji do przerysowania zebraną jak w Concepcie
         (zdarzenie cart:bundled-sections, szuflada i /cart dopisują swoje id; cart.js),
      b) pełny /cart.js z doklejonymi sekcjami z odpowiedzi i publikacja cartUpdate przez theme.pubsub, tak jak ProductForm
         w theme.js: CartItems (cart.js) przerysowuje #MiniCart-<id> i #MainCart-<id> razem z panelem (bez dodanej usługi,
         a gdy nic nie zostało, bez panelu), CartCount odświeża licznik w nagłówku.
         Zapasowo, gdyby nie było theme.pubsub: podmiana tych elementów z sekcji z odpowiedzi add.js; bez sekcji w odpowiedzi
         szuflada dostaje cart:refresh Concepta, a /cart przeładowanie strony,
      c) po odświeżeniu fokus na "Dodaj" w tym samym miejscu listy (następna usługa), a gdy panel zniknął, na nazwę dodanej
         pozycji. Na /cart Concept po odświeżeniu zakłada pułapkę fokusu na treść koszyka (theme.a11y.trapFocus), tu ją
         zdejmujemy, bo /cart to zwykła strona, nie okno dialogowe (w szufladzie pułapka zostaje, jak w Concepcie),
      d) stan ładowania: aria-busy + aria-disabled i ikona obrotu w przycisku; jedno dodanie naraz; komunikat dla czytnika
         ekranu w regionie role="status" dopinanym poza przerysowywaną treścią (w szufladzie w .drawer__inner, na /cart w .cart),
         błąd (np. brak na stanie) pod listą w role="alert": "Nie udało się dodać usługi. Spróbuj jeszcze raz.", przycisk
         wraca do "Dodaj". */
(() => {
  const BUTTON = '[data-motus-usluga]';
  const PANEL = '[data-motus-koszyk-uslugi]';
  let busy = false;

  const announce = (host, text) => {
    if (!host) return;
    let region = host.querySelector(':scope > .motus-cart-uslugi-live');
    if (!region) {
      region = document.createElement('p');
      region.className = 'motus-cart-uslugi-live sr-only';
      region.setAttribute('role', 'status');
      host.appendChild(region);
    }
    region.textContent = '';
    setTimeout(() => {
      region.textContent = text;
    }, 100);
  };

  const setLoading = (button, on) => {
    const loader = button.querySelector('.motus-cart-uslugi__loader');
    if (on) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
    if (loader) loader.hidden = !on;
  };

  /* a) */
  const sectionsToRender = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return Array.from(new Set(sections));
  };

  /* b) zapas */
  const swapFromSections = (sections) => {
    Object.keys(sections).forEach((id) => {
      if (!sections[id]) return;
      const fresh = new DOMParser().parseFromString(sections[id], 'text/html');
      [`MiniCart-${id}`, `MainCart-${id}`].forEach((elementId) => {
        const current = document.getElementById(elementId);
        const next = fresh.getElementById(elementId);
        if (current && next) current.innerHTML = next.innerHTML;
      });
    });
  };

  /* c) */
  const focusAfter = (drawer, index, key) => {
    const scope = drawer || document;
    const panel = scope.querySelector(PANEL);
    const buttons = panel ? Array.from(panel.querySelectorAll(BUTTON)) : [];
    let target = buttons.length ? buttons[Math.min(index, buttons.length - 1)] : null;
    if (!target && key) {
      const line = document.getElementById(`CartDrawer-Item-${key}`) || document.getElementById(`CartItem-${key}`);
      target = line ? line.querySelector('.horizontal-product__title a, .cart__item-title, a[href]') : null;
    }
    if (!target) return;
    /* fokus bez przewijania, potem cały wiersz w widoku (samo focus() pokazywało tylko przycisk, bez korzyści pod nim) */
    target.focus({ preventScroll: true });
    (target.closest('li') || target).scrollIntoView({ block: 'nearest' });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest(BUTTON) : null;
    if (!button) return;
    event.preventDefault();
    if (busy || button.getAttribute('aria-disabled') === 'true') return;

    const panel = button.closest(PANEL);
    const drawer = button.closest('cart-drawer');
    const host = drawer ? drawer.querySelector('.drawer__inner') || drawer : button.closest('.cart') || document.body;
    const name = button.getAttribute('data-motus-usluga-nazwa') || '';
    const index = panel ? Array.from(panel.querySelectorAll(BUTTON)).indexOf(button) : 0;
    const error = panel ? panel.querySelector('.motus-cart-uslugi__error') : null;
    const routes = (window.theme && window.theme.routes) || {};
    const pubsub = window.theme && window.theme.pubsub;

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    busy = true;
    setLoading(button, true);

    try {
      const response = await fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(button.getAttribute('data-motus-usluga')), quantity: 1 }],
          sections: sectionsToRender(),
          sections_url: window.location.pathname
        })
      });
      const parsed = await response.json();
      /* odmowa Shopify (422, np. brak na stanie) albo inny błąd: opis Shopify bywa po angielsku ("Cannot find variant"),
         więc klient widzi zawsze komunikat po polsku (catch) */
      if (!response.ok || parsed.status) throw new Error(parsed.description || String(response.status));

      const key = parsed.items && parsed.items[0] ? parsed.items[0].key : null;
      const hasSections = parsed.sections && Object.keys(parsed.sections).length > 0;

      /* b) */
      if (pubsub && hasSections) {
        const cart = await (await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })).json();
        cart.sections = parsed.sections;
        pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'motus-uslugi', cart });
      } else if (hasSections) {
        swapFromSections(parsed.sections);
      } else if (drawer) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      } else {
        window.location.reload();
        return;
      }

      /* c) */
      if (!drawer && window.theme && window.theme.a11y) window.theme.a11y.removeTrapFocus();
      focusAfter(drawer, index, key);
      announce(host, ((window.motusTeksty || {}).dodano || 'Dodano do koszyka: {nazwa}').replace('{nazwa}', () => name));
    } catch {
      if (button.isConnected) setLoading(button, false);
      if (error && error.isConnected) {
        error.textContent = (window.motusTeksty || {}).bladUslugi || 'Nie udało się dodać usługi. Spróbuj jeszcze raz.';
        error.hidden = false;
      }
    } finally {
      busy = false;
    }
  });
})();

/* 7. Przełącznik modeli na telefonie i tablecie (< 1024 px): nowa karta otwiera się w tym samym miejscu ekranu
      (uwaga Michała 27.09: "Dodaj do koszyka" tuż pod wyborem modelu). Miniatury modeli (blok product_variations,
      snippets/product-variants.liquid) to zwykłe linki do innych produktów, więc po wyborze modelu przeglądarka ładuje
      nową kartę od góry: klient widzi galerię, a wybór modelu i przycisk są znowu pod pierwszym ekranem (Pro 10 Daytona
      przy 375 px: przycisk 274 px pod nim). Przed przejściem zapisujemy (sessionStorage, tylko ta karta przeglądarki),
      gdzie na ekranie stał wybór modelu, a nowa karta przewija się tak, żeby stał w tym samym miejscu: cena, miniatury
      i przycisk nie skaczą. Działa tylko przy zwykłym przejściu z linku (nie przy odświeżeniu ani "wstecz"), do 20 s
      po kliknięciu, a gdy klient sam zacznie przewijać, skrypt nie poprawia już pozycji. Desktop (od 1024 px) bez zmian. */
(() => {
  const KEY = 'motus:pozycja-modelu';
  const LINK = '.product__info .variant-picker a[href*="/products/"]';

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest(LINK) : null;
    if (!link || window.innerWidth >= 1024) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const to = new URL(link.href, location.href).pathname;
    if (to === location.pathname) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ to, top: link.closest('.variant-picker').getBoundingClientRect().top, at: Date.now() }));
    } catch {}
  }, true);

  let saved = null;
  try {
    saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    sessionStorage.removeItem(KEY);
  } catch {}
  if (!saved || saved.to !== location.pathname || Date.now() - saved.at > 20000 || window.innerWidth >= 1024) return;
  const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  if (nav && nav.type !== 'navigate') return;

  let userScrolled = false;
  ['wheel', 'touchstart', 'keydown'].forEach((type) => window.addEventListener(type, () => { userScrolled = true; }, { once: true, passive: true }));
  const align = () => {
    if (userScrolled) return;
    const link = document.querySelector(LINK);
    if (!link) return;
    const delta = link.closest('.variant-picker').getBoundingClientRect().top - saved.top;
    if (Math.abs(delta) > 1) window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', align, { once: true });
  else align();
  if (document.readyState !== 'complete') window.addEventListener('load', () => { align(); setTimeout(align, 400); }, { once: true });
})();
